import { useState, type FormEvent } from "react";
import { api, ApiError, jsonOptions } from "./api";
import type { SessionUser } from "../shared/types";

export function LoginPage({ onLogin }: { onLogin: (user: SessionUser) => void }) {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [submitting, setSubmitting] = useState(false);

  async function submit(event: FormEvent) {
    event.preventDefault();
    setSubmitting(true); setError("");
    try {
      const result = await api<{ user: SessionUser }>("/auth/login", jsonOptions("POST", { username, password }));
      onLogin(result.user);
    } catch (cause) {
      setError(cause instanceof ApiError ? cause.message : "登录失败，请重试。");
    } finally { setSubmitting(false); }
  }

  return <main className="login-page">
    <section className="login-brand">
      <div className="brand-symbol large"><span /><span /><span /></div>
      <p className="eyebrow">PERSONAL TIME SYSTEM</p>
      <h1>看清时间<br />流向哪里。</h1>
      <p>把一天拆成真实的分钟，让学习、生活与休息都有迹可循。</p>
      <div className="login-preview" aria-hidden="true">
        <div className="preview-line"><i className="preview-a" style={{ width: "48%" }} /><i className="preview-b" style={{ width: "32%" }} /><i className="preview-c" style={{ width: "20%" }} /></div>
        <div><span>今日时间分配</span><span>今日已记录 82%</span></div>
      </div>
    </section>
    <section className="login-panel">
      <form className="login-card" onSubmit={submit}>
        <div><p className="eyebrow">TIMEFLOW</p><h2>欢迎回来</h2><p>登录你的个人时间工作台</p></div>
        {error && <div className="error-banner" role="alert">{error}</div>}
        <label>用户名<input autoFocus autoComplete="username" value={username} onChange={(e) => setUsername(e.target.value)} placeholder="输入用户名" /></label>
        <label>密码<input type="password" autoComplete="current-password" value={password} onChange={(e) => setPassword(e.target.value)} placeholder="输入密码" /></label>
        <button className="primary-button full" type="submit" disabled={submitting}>{submitting ? "正在验证…" : "进入 TimeFlow"}</button>
        <small>你的记录仅保存在自己的 Cloudflare 数据库中。</small>
      </form>
    </section>
  </main>;
}
